/**
 * 레퍼런스 : https://github.kakaocorp.com/kakaopage/api/blob/58db0cf06dce37e800e5aee64250899a8684fb30/common/src/main/java/com/kakaopage/common/CommonCodes.java#L39
 */
export enum UserStateVo {
  // @deprecated
  PreMember = 'UST0', // 준회원

  RegularMember = 'UST1', // 정회원
  LeaveMember = 'UST2', // 탈퇴자
  DormantAccount = 'UST4', // 휴면계정
  NonMember = 'USTN', // 비회원
}
